"use client";

import { useEffect } from "react";
import Script from "next/script";
import {
  identifyNavatticInitialProperties,
  registerNavatticEventHandler,
} from "@/helpers/navattic";

export const Navattic = ({ campaignId }: { campaignId?: string }) => {
  useEffect(() => {
    const initializeNavattic = async () => {
      await registerNavatticEventHandler();
      await identifyNavatticInitialProperties(campaignId);
    };

    initializeNavattic();
  }, [campaignId]);

  return (
    <>
      <Script
        id="navattic-queue"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html:
            "void 0===window.navatticQueue&&(window.navatticQueue=[],window.navattic=new Proxy({},{get:function n(t,u,e){return function(){for(var n=arguments.length,t=Array(n),e=0;e<n;e++)t[e]=arguments[e];return navatticQueue.push({function:u,arguments:t})}}}));",
        }}
      />
      <Script
        id="navattic-sdk"
        src="https://js.navattic.com/sdk.js?key=pkey_cm34kx30k02lsrs3bfkrm6x35"
        strategy="afterInteractive"
      />
    </>
  );
};
